import React, {
  useEffect,
  useState,
} from "react";
import "./App.css";
import HomePage from "./HomePage";
import EnquiryPage from "./EnquiryPage";
import {
  AuthPage,
  TopNav,
  FloatingContact,
  Dashboard,
  MembersPage,
  MemberForm,
  InvoicePage,
  MembershipPage,
  GymPage,
} from "./DashboardPages";
// =====================================
// APP
// =====================================
function App() {
  const [screen, setScreen] = useState("home");

  const [currentUser, setCurrentUser] =
    useState(() => {
      const saved =
        localStorage.getItem(
          "fitrackCurrentUser"
        );

      return saved
        ? JSON.parse(saved)
        : null;
    });


  const [members, setMembers] =
    useState(() => {

      const saved =
        localStorage.getItem(
          "fitrackMembers"
        );

      return saved
        ? JSON.parse(saved)
        : [];

    });


  const [selectedMember, setSelectedMember] =
    useState(null);


  const [editingMember, setEditingMember] =
    useState(null);


  const [darkMode, setDarkMode] =
    useState(() => {

      const saved =
        localStorage.getItem(
          "fitrackDarkMode"
        );

      return saved === null
        ? true
        : saved === "true";
    });


  // ===================================
  // SAVE MEMBERS
  // ===================================

  useEffect(() => {

    localStorage.setItem(
      "fitrackMembers",
      JSON.stringify(members)
    );

  }, [members]);


  // ===================================
  // SAVE THEME
  // ===================================

  useEffect(() => {

    localStorage.setItem(
      "fitrackDarkMode",
      darkMode
    );

  }, [darkMode]);


  // ===================================
  // LOGIN
  // ===================================

  const handleLogin = (user) => {

    setCurrentUser(user);

    setScreen("dashboard");
  };


  // ===================================
  // LOGOUT
  // ===================================

  const logout = () => {

    localStorage.removeItem(
      "fitrackCurrentUser"
    );

    setCurrentUser(null);

    setScreen("home");
  };


  // ===================================
  // ADD MEMBER
  // ===================================

  const addMember = () => {

    setEditingMember(null);

    setScreen("add-member");
  };


  // ===================================
  // EDIT MEMBER
  // ===================================

  const editMember = (member) => {

    setEditingMember(member);

    setScreen("add-member");
  };


  // ===================================
  // SAVE MEMBER
  // ===================================

  const saveMember = (member) => {

    setMembers((previous) => {

      const exists = previous.some(
        (item) =>
          item.id === member.id
      );


      if (exists) {

        return previous.map((item) =>
          item.id === member.id
            ? member
            : item
        );

      }


      return [
        ...previous,
        member,
      ];

    });


    setEditingMember(null);

    setScreen("members");
  };


  // ===================================
  // DELETE MEMBER
  // ===================================

  const deleteMember = (id) => {

    const confirmDelete =
      window.confirm(
        "Are you sure you want to delete this member?"
      );


    if (!confirmDelete) {
      return;
    }


    setMembers((previous) =>
      previous.filter(
        (member) =>
          member.id !== id
      )
    );

  };


  // ===================================
  // INVOICE
  // ===================================

  const openInvoice = (member) => {

    setSelectedMember(member);

    setScreen("invoice");
  };


  // ===================================
  // MAIN SCREEN
  // ===================================

  const renderScreen = () => {


    // HOME
    if (screen === "home") {

      return (
        <HomePage
          onLogin={() =>
            setScreen("login")
          }

          onSignup={() =>
            setScreen("signup")
          }

          onEnquire={() =>
            setScreen("enquiry")
          }

          darkMode={darkMode}

          setDarkMode={setDarkMode}
        />
      );

    }


    // ENQUIRY
    if (screen === "enquiry") {

      return (
        <EnquiryPage
          onBack={() => {

            if (currentUser) {
              setScreen("dashboard");
            } else {
              setScreen("home");
            }

          }}

          darkMode={darkMode}

          setDarkMode={setDarkMode}
        />
      );

    }


    // LOGIN
    if (screen === "login") {

      return (
        <AuthPage
          mode="login"

          onBack={() =>
            setScreen("home")
          }

          onSuccess={handleLogin}

          darkMode={darkMode}

          setDarkMode={setDarkMode}
        />
      );

    }


    // SIGNUP
    if (screen === "signup") {

      return (
        <AuthPage
          mode="signup"

          onBack={() =>
            setScreen("home")
          }

          onSuccess={handleLogin}

          darkMode={darkMode}

          setDarkMode={setDarkMode}
        />
      );

    }


    // INVOICE
    if (screen === "invoice") {

      return (
        <>
          <TopNav
            currentUser={currentUser}
            screen={screen}
            setScreen={setScreen}
            logout={logout}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />

          <InvoicePage
            member={selectedMember}
            onBack={() =>
              setScreen("members")
            }
          />
        </>
      );

    }


    // ADD MEMBER
    if (screen === "add-member") {

      return (
        <>
          <TopNav
            currentUser={currentUser}
            screen={screen}
            setScreen={setScreen}
            logout={logout}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />

          <MemberForm
            initialMember={editingMember}
            onSave={saveMember}
            onCancel={() =>
              setScreen("members")
            }
          />
        </>
      );

    }


    // MEMBERS
    if (screen === "members") {

      return (
        <>
          <TopNav
            currentUser={currentUser}
            screen={screen}
            setScreen={setScreen}
            logout={logout}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />

          <MembersPage
            members={members}

            onAdd={addMember}

            onEdit={editMember}

            onInvoice={openInvoice}

            onDelete={deleteMember}
          />
        </>
      );

    }


    // MEMBERSHIP
    if (screen === "membership") {

      return (
        <>
          <TopNav
            currentUser={currentUser}
            screen={screen}
            setScreen={setScreen}
            logout={logout}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />

          <MembershipPage
            onAdd={addMember}
          />
        </>
      );

    }


    // GYM
    if (screen === "gym") {

      return (
        <>
          <TopNav
            currentUser={currentUser}
            screen={screen}
            setScreen={setScreen}
            logout={logout}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />

          <GymPage />
        </>
      );

    }


    // DASHBOARD
    return (
      <>
        <TopNav
          currentUser={currentUser}
          screen={screen}
          setScreen={setScreen}
          logout={logout}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
        />

        <Dashboard
          members={members}
          setScreen={setScreen}
        />
      </>
    );
  };


  return (
    <div
      className={`app ${
        darkMode
          ? "dark-mode"
          : "light-mode"
      }`}
    >

      {renderScreen()}


      {/* Floating WhatsApp + Call */}

      {screen !== "login" &&
        screen !== "signup" && (
          <FloatingContact />
        )}

    </div>
  );
}

export default App;